import React from 'react';
import './DataInnovation.css';
import dataInnovation from '../../images/innovation.jpg';
import bigdata from "../../images/bigdata.jpg";
import ml from "../../images/ml.jpg";
import ai from "../../images/aipic.jpg";
import Header from "../../Header/Header"
import HeroSection from '../../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class DataInnovation extends React.Component{
     componentDidMount() {
         ReactGA.pageview('/data-innovation');
     }
    render() {
        window.scrollTo(0, 0);
       return (
        <div className="solution-page innovation-page">
            <Header />
            <HeroSection pageTitle="Solutions" background={dataInnovation} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/data-innovation" className="current">Data Innovation</Link></li>
                    </ul>
                </Container>
                <div className="solution-page-list">
                    <Container className="no-margin">
                        <div className="node-title">
                            <div></div>
                            <i className="fa fa-circle"></i>
                            <span> Data Innovation </span>
                            <i className="fa fa-circle"></i>
                            <div></div>
                        </div>
                        <div className="page-description-container">
                            <i className="fa fa-circle"></i>
                            <div className="page-description">
                                <p>
                                    We have a team of data analysts and machine learning experts building the next generation of machine learning models and Artificial Intelligence algorithms to help you understand the impact of marketing campaigns, player behaviour and adjust customer offers.
                                </p>
                            </div>
                            <i className="fa fa-circle"></i>
                        </div>
                    </Container>
                    <div className="fullwidth-grid">
                        <Row className="row-eq-height">
                            <Col col="md-6 12" className="image-block">
                                <Slide left>
                                    <img src={bigdata}/>
                                </Slide>
                            </Col>
                            <Col col="md-6 12" className="list-text">
                                <div className="middle-center">
                                    <Slide right>
                                        <h3>Big Data</h3>
                                        <p>
                                            Moobifun offers big data powered actionable analytics to deliver the best results. Our Big Data analytics platform ensures our clients can quickly penetrate digital markets and generate new revenue streams.
                                        </p>
                                    </Slide>
                                </div>
                            </Col>
                        </Row>
                        <Row className="row-eq-height flip-order">
                            <Col col="md-6 12" className="list-text">
                                <div className="middle-center">
                                    <Fade left delay={1000}>
                                        <h3>MAchine Learning</h3>
                                        <p>
                                            We devise machine learning models and artificial intelligence algorithms to improve your business analysis and enrich the users’ experience.
                                        </p>
                                    </Fade>
                                </div>
                            </Col>
                            <Col col="md-6 12" className="image-block">
                                <Fade right delay={1000}>
                                    <img src={ml} />
                                </Fade>
                            </Col>
                        </Row>
                        <Row className="row-eq-height" >
                            <Col col="md-6 12" className="image-block">
                                <Slide left>
                                    <img src={ai} />
                                </Slide>
                            </Col>
                            <Col col="md-6 12" className="list-text">
                                <div className="middle-center">
                                    <Slide right>
                                        <h3>Artificial Intelligence</h3>
                                        <p>
                                            We employ model-based reasoning methodology to mimic the cognitive functions that humans associate with other human minds such as learning, reasoning and problem solving. This is the essence of Artificial Intelligence and our clients benefit from the insights we can bring to their business by means of AI.
                                        </p>
                                    </Slide>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
       );
    }
}
export default DataInnovation;
